import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';

const PriceRangeCard = ({ stockData }) => {
  const { fiftyTwoWeekLow: lo, fiftyTwoWeekHigh: hi, price } = stockData;
  const pct = lo && hi ? Math.min(100, Math.max(0, ((price - lo) / (hi - lo)) * 100)) : null;
  return (
    <Card>
      <CardHeader>
        <CardTitle>52-Week Price Range</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600 mb-1">52-Week Low</p>
              <p className="text-2xl font-bold text-red-600">${lo ? lo.toFixed(2) : 'N/A'}</p>
            </div>
            <div className="text-right">
              <p className="text-sm text-gray-600 mb-1">52-Week High</p>
              <p className="text-2xl font-bold text-green-600">${hi ? hi.toFixed(2) : 'N/A'}</p>
            </div>
          </div>

          {pct !== null && (
            <div className="relative">
              <div className="h-3 bg-gradient-to-r from-red-200 via-yellow-200 to-green-200 rounded-full" />
              <div
                className="absolute top-0 w-4 h-4 bg-purple-600 rounded-full border-2 border-white shadow-lg transform -translate-x-1/2 -translate-y-0.5"
                style={{ left: `${pct}%` }}
              />
            </div>
          )}

          <div className="flex items-center justify-center gap-2 text-sm text-gray-600">
            <span>Current Price: </span>
            <Badge className="bg-purple-600 text-white">${price.toFixed(2)}</Badge>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default PriceRangeCard;
